import {
    SYSTEM_CHOOSE_CURRENT_WORKEXPERIENCE,
} from './constants';
  
export function chooseCurrentWorkExperience(modal) {
    return {
      type: SYSTEM_CHOOSE_CURRENT_WORKEXPERIENCE,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_CHOOSE_CURRENT_WORKEXPERIENCE:
        return {
          ...state,
          currentWorkExperience:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/system/redux/chooseCurrentWorkExperience.js